import { useHistory } from 'react-router-dom'
import { ROUTES } from '@sportninja/common/constants/app'
import type { BreadcrumbItem } from 'src/components/ts-components/Breadcrumb'
import type { ModalTrailItem } from '../types/modalTrail'

export interface ModalBreadcrumbs {
  items: BreadcrumbItem[] | undefined
  /** The home icon: close (guarded), then go to the home page. */
  onHome: () => void
}

/**
 * The header breadcrumb for a full-screen player screen: where it was opened
 * from (the entry point's trail), after a home icon — the page headers' look.
 * A crumb with a page is a link: it closes the screen through the same guard
 * as Close (so unsaved edits still warn first), then goes there. One without a
 * page only names where the user is. The screen's own name is the title
 * below, so it is not repeated as a crumb.
 */
export const useModalBreadcrumbs = (
  trail: ModalTrailItem[] | undefined,
  requestClose: (afterClose?: () => void) => void
): ModalBreadcrumbs => {
  'use memo'

  const history = useHistory()

  return {
    items: trail?.length
      ? trail.map(({ label, to }, index) => ({
          key: `${index}-${label}`,
          label,
          onSelect: to ? () => requestClose(() => history.push(to)) : undefined,
        }))
      : undefined,
    onHome: () => requestClose(() => history.push(ROUTES.HOME)),
  }
}
